export default __webpack_public_path__ + "static/impact-strategies-logo-99662ecd4ba6b28d01462ac1059e9b59.svg";